import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <motion.a
    href="https://wa.me/393296330445?text=Buongiorno%20Valentina%2C%20vorrei%20informazioni%20sulla%20mediazione%20familiare."
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Scrivimi su WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-6 right-6 z-50 group inline-flex items-center justify-center w-14 h-14 rounded-full bg-ink text-gold shadow-[0_16px_40px_-12px_rgba(20,41,46,0.55)] hover:bg-night hover:-translate-y-1 active:scale-95 transition-all duration-300"
  >
    <span className="absolute inset-0 rounded-full border border-gold/50 animate-ping [animation-duration:2.6s] pointer-events-none" />
    <MessageCircle size={24} />
    <span className="absolute right-full mr-3 whitespace-nowrap rounded-full bg-night text-paper text-xs font-semibold px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
      Scrivimi su WhatsApp
    </span>
  </motion.a>
);
